(function(d) {
    var config = {
        kitId: "ysi4rlt",
        scriptTimeout: 10000,
        async: true,
        active: finish,
        inactive: fail
    }, h = d.documentElement, t = setTimeout(fail, config.scriptTimeout), tk = d.createElement("script"), f = false, s = d.getElementsByTagName("script")[0], a;
    function finish() {
        clearTimeout(t);
        h.classList.remove("fonts-pending");
    }
    function fail() {
        h.classList.remove("wf-loading");
        h.classList.add("wf-inactive");
        finish();
    }
    h.className += " wf-loading";
    tk.src = "https://use.typekit.net/" + config.kitId + ".js";
    tk.async = true;
    tk.onload = tk.onreadystatechange = function() {
        a = this.readyState;
        if (f || a && a != "complete" && a != "loaded") return;
        f = true;
        try {
            Typekit.load(config);
        } catch (e) {
            fail();
        }
    };
    tk.onerror = fail;
    s.parentNode.insertBefore(tk, s);
})(document);

//# sourceMappingURL=index.2f427831.js.map
